import { render, staticRenderFns } from "./ChallengerDetailJudge.vue?vue&type=template&id=4c0abee9&scoped=true"
import script from "./ChallengerDetailJudge.vue?vue&type=script&lang=ts"
export * from "./ChallengerDetailJudge.vue?vue&type=script&lang=ts"
import style0 from "./ChallengerDetailJudge.vue?vue&type=style&index=0&id=4c0abee9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c0abee9",
  null
  
)

export default component.exports